import { render, staticRenderFns } from "./AboutOwner.vue?vue&type=template&id=1cbbc7ea&"
import script from "./AboutOwner.vue?vue&type=script&lang=js&"
export * from "./AboutOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports